<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6">
</a><h2 class="fmtitle"><a id="VPS-6"></a><a id="map">List of Maps</a></h2><a id="map">
<p class="map">General map of the area</p>
<p class="map">A map drawn by Captain Eric Jones showing the deployment of the 2/Gloucesters at Cassel</p>
<p class="map">A map drawn by Captain Bill Wilson showing the deployment of B and D Companies at Cassel</p>
<p class="map">A map taken from <em class="italic">The New Contemptibles</em> showing the 5/RHA positions at Hondeghem</p>
<p class="map">A map taken from <em class="italic">The New Contemptibles</em> showing the 5/RHA positions at St-Sylvestre-Cappel</p>
<p class="map">A map of the Woodforce deployment at Hazebrouck</p>
<p class="map">A map showing the deployment of the 1/Bucks at Hazebrouck</p>
<p class="map">A map taken from the <em class="italic">Ox and Bucks Regimental Journal, July 1943</em>, depicting the 1/Bucks’ positions at Hazebrouck</p>
<p class="map">Car Tour 1</p>
<p class="map">Walk 2</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List_of_Maps.vue?425d329b